import { MediaAssetImageProps } from "design-system/components/primitives/media-asset/media-asset-image";
import { PersonTeaseProps } from "design-system/components/primitives/person-tease/person-tease";
import {
  FeaturedTermTopperFacultyHit,
  LegacySearchHit,
  ModernSearchHit,
  SearchDisplay,
} from "frontend/types";
import { isSearchHitType } from "./is-search-hit-type";

export function createSearchPersonTease(
  data?: LegacySearchHit,
  thumbnailProps?: Partial<MediaAssetImageProps>,
): PersonTeaseProps | undefined {
  if (data && typeof data === "object") {
    const props: PersonTeaseProps = {
      type: "Person",
      link: data.HBSLink,
      bio: data.HBSDescription,
    };

    if (data.HBSTitle) {
      props.name = data.HBSTitle;
    }

    if (data.HBSThumbnail) {
      props.portrait = {
        src: data.HBSThumbnail,
        ...thumbnailProps,
      };
    }

    return props;
  }
}

export function createModernSearchPersonTease(
  data?: ModernSearchHit | SearchDisplay,
): PersonTeaseProps | undefined {
  if (data && typeof data === "object") {
    const props: PersonTeaseProps = {
      type: "Person",
      link: data.url,
    };

    if (data.title) {
      props.name = data.title;
    }

    if (data.description) {
      props.titles = [data.description];
    }

    //get image path from data.display.thumbnail.source
    if (isSearchHitType<SearchDisplay>("modern", data)) {
      if (data.display?.thumbnail?.src) {
        props.portrait = {
          src: data.display?.thumbnail.src,
          gravity: data.display.thumbnail.gravity,
          alt: data.display.thumbnail.alt,
          aspectRatio: data.display.thumbnail.aspectRatio,
        };
      }
    }

    return props;
  }
}

export function createArticleSearchPersonTease(
  data?: FeaturedTermTopperFacultyHit,
): Array<PersonTeaseProps> | undefined {
  if (data && typeof data === "object" && data.display?.personTeases?.length) {
    const personSet = new Set<string>();
    const personTeases = new Array<PersonTeaseProps>();

    data.display.personTeases.forEach((personTease) => {
      if (!personSet.has(personTease.name)) {
        personSet.add(personTease.name);

        const props: PersonTeaseProps = {
          type: "Person",
          name: personTease.name,
          link: personTease.url,
          titles: Array.isArray(personTease.titles) ? personTease.titles : [],
        };

        if (personTease.thumbnail?.src) {
          props.portrait = {
            src: personTease.thumbnail.src,
          };
        }

        personTeases.push(props);
      }
    });

    return personTeases.length > 0 ? personTeases : undefined;
  }
  return undefined;
}
